import * as yup from 'yup';
import ValidationMessage from '../../constants/Validation/ValidationMessage';
import ValidationMessageAlbanian from '../../constants/Validation/ValidationMessageChange';

const emojiFreeRegex = /^[\w\s\.,'!&@()-]+$/;

const local_language = localStorage.getItem('lang')


const RegisterValidation: any = yup.object().shape({

    salon_name: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("emri i sallonit") : ValidationMessage.Field("salon name"))
        .min(3, local_language == "alb" ? ValidationMessageAlbanian.MinLength("emri i sallonit", 3) : ValidationMessage?.MinLength("salon name ", 3))
        .max(25, local_language == "alb" ? ValidationMessageAlbanian.MaxLength("emri i sallonit", 3) : ValidationMessage?.MaxLength("salon name", 25))
        .matches(emojiFreeRegex, (local_language == "alb" ? "Emoji nuk lejohen" : "Emojis not allowed")),
    // .matches(/^[\s\S]*$/, 'Salon name must contain valid characters'), // This allows all characters including special ones




    email: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("email") : ValidationMessage.Field("email"))
        .email(local_language == "alb" ? ValidationMessageAlbanian.EMAIL_ADDRESS : ValidationMessage.EMAIL_ADDRESS)
        .matches(ValidationMessage.EMAIL_REGREX, local_language == "alb" ? ValidationMessageAlbanian.EMAIL_ADDRESS : ValidationMessage.EMAIL_ADDRESS)
        .max(150, local_language == "alb" ? ValidationMessageAlbanian.MaxLength('Email', 150) : ValidationMessage.MaxLength('Email', 150))
        .trim(),


    // phone_number: yup.string().required(ValidationMessage.Field("phone number"))
    //     .min(10, ValidationMessage?.VALID_PHONE_NUMBER)
    //     .max(10, ValidationMessage?.PHONE_MAX_CHAR),
    // phone_number: yup.string().required(ValidationMessage.Field("phone number"))
    //     .min(7, ValidationMessage?.VALID_PHONE_NUMBER)
    //     .max(15, ValidationMessage?.PHONE_MAX_CHAR),


    phone_number: yup.string()
        .required(local_language == "alb" ? ValidationMessageAlbanian.Field("Numri i telefonit") : ValidationMessage.Field("phone number"))
        .min(7, local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE_NUMBER : ValidationMessage.VALID_PHONE_NUMBER)
        .max(15, local_language == "alb" ? ValidationMessageAlbanian.PHONE_MAX_CHAR : ValidationMessage.PHONE_MAX_CHAR)
        .matches(/^[0-9]*$/, local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE_NUMBER : ValidationMessage.VALID_PHONE_NUMBER) // Allow only digits
        .test('valid-phone', local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE : ValidationMessage.VALID_PHONE, value => {
            // Ensure phone number is not just repeated '0's
            if (!value) return true; // Return true if value is not provided (handled by required validation)

            if (/^0+$/.test(value)) {
                return false; // Reject if all characters are '0'
            }

            return true;
        }),

    // password: yup.string().required(ValidationMessage.Field("password"))
    //     .min(4, ValidationMessage?.MinLength('Password', 8))
    //     .max(15, ValidationMessage?.MaxLength('Password', 15))
    //     .matches(/^\S*$/, ValidationMessage?.NO_SPACE_ALLOWED)
    //     .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()\[\]=+_\-]{8,15}$/, ValidationMessage?.PASSWORD_UPPER_CASE),

    // confirm_password: yup.string().required(ValidationMessage.Field("confirm password"))
    //     .min(4, ValidationMessage?.MinLength('Confirm password', 4))
    //     .max(15, ValidationMessage?.MaxLength('Confirm password', 15))
    //     .oneOf([yup.ref('password')], ValidationMessage?.PASSWORD_CONFIRM_PASSWORD_MUST_MATCH),
    password: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("fjalëkalimin") : ValidationMessage.Field("password"))
        .min(8, local_language == "alb" ? ValidationMessageAlbanian?.MinLength('fjalëkalimin', 8) : ValidationMessage?.MinLength('Password', 8))
        .max(15, local_language == "alb" ? ValidationMessageAlbanian?.MaxLength('fjalëkalimin', 15) : ValidationMessage?.MaxLength('Password', 15))
        .matches(/^\S*$/, local_language == "alb" ? ValidationMessageAlbanian?.NO_SPACE_ALLOWED : ValidationMessage?.NO_SPACE_ALLOWED)
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()\[\]=+_\-]{8,15}$/, local_language == "alb" ? ValidationMessageAlbanian?.PASSWORD_UPPER_CASE : ValidationMessage?.PASSWORD_UPPER_CASE),

    confirm_password: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("konfirmoni fjalëkalimin") : ValidationMessage.Field("confirm password"))
        .min(8, local_language == "alb" ? ValidationMessageAlbanian?.MinLength('Konfirmo fjalëkalimin', 8) : ValidationMessage?.MinLength('Confirm password', 8))
        .max(15, local_language == "alb" ? ValidationMessageAlbanian?.MaxLength('Konfirmo fjalëkalimin', 15) : ValidationMessage?.MaxLength('Confirm password', 15))
        .oneOf([yup.ref('password')], local_language == "alb" ? ValidationMessageAlbanian?.PASSWORD_CONFIRM_PASSWORD_MUST_MATCH : ValidationMessage?.PASSWORD_CONFIRM_PASSWORD_MUST_MATCH),


    agree: yup.boolean().required(local_language == "alb" ? 'Ju lutemi pranoni Termat dhe Kushtet dhe Politikën e Privatësisë.' : 'Please accept Terms & Conditions and Privacy Policy.')
        .oneOf([true], local_language == "alb" ? 'Ju lutemi pranoni Termat dhe Kushtet dhe Politikën e Privatësisë.' : "Please accept Terms & Conditions and Privacy Policy."),

    phone_country_code: yup.string().required(),
});

export default RegisterValidation;

